import { LightboxProvider } from "@/components/Lightbox";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Home, Flower2, ClipboardList, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

const TABS = [
  { to: "/store", end: true, label: "Home", icon: Home, id: "home" },
  { to: "/store/catalogue", label: "Catalogue", icon: Flower2, id: "catalogue" },
  { to: "/store/orders", label: "Orders", icon: ClipboardList, id: "orders" },
];

export default function StoreLayout() {
  const { store, logoutStore } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logoutStore(); navigate("/login"); };

  return (
    <CartProvider>
      <div className="bg-terracotta min-h-screen text-white">
        <header className="mx-auto flex max-w-3xl items-center justify-between px-5 pt-6">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.15em] text-[#EBBAD1]">Welcome back</div>
            <div className="font-serif text-2xl font-extrabold leading-tight">{store?.store_name}</div>
            <div className="text-sm font-medium text-white/85">{store?.location || `Store ${store?.store_code}`}</div>
          </div>
          <button data-testid="logout-button" onClick={doLogout} className="grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20"><LogOut className="h-4 w-4" /></button>
        </header>

        <main className="mx-auto max-w-3xl px-5 pb-28 pt-4"><LightboxProvider><Outlet /></LightboxProvider></main>

        <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#28282E]/95 backdrop-blur">
          <div className="mx-auto flex max-w-3xl">
            {TABS.map((t) => (
              <NavLink key={t.id} to={t.to} end={t.end} data-testid={`storetab-${t.id}`}
                className={({ isActive }) => `flex flex-1 flex-col items-center gap-1 py-3 text-[11px] font-semibold ${isActive ? "text-[#EBBAD1]" : "text-white/85"}`}>
                <t.icon className="h-5 w-5" /> {t.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </CartProvider>
  );
}
